import { render, staticRenderFns } from "./blog.vue?vue&type=template&id=2d987a41&scoped=true&"
import script from "./blog.vue?vue&type=script&lang=ts&"
export * from "./blog.vue?vue&type=script&lang=ts&"
import style0 from "./blog.vue?vue&type=style&index=0&id=2d987a41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d987a41",
  null
  
)

export default component.exports